module.exports = __webpack_public_path__ + "img/horizontal_6_7_9016.06e4a4cf.png";